import { Result, ResultMetadataType } from '@zxing/library'

/**
 * 分割QRコードの総枚数と現在位置を求める。
 * 注意として、現在位置は１始まりなので、Indexにする際は-1をする
 * @param {Result} result - QRコードで読み取った結果
 */
export const getPositionAndTotal = (result: Result) => {
  const meta = result.getResultMetadata()
  const sequense = meta.get(ResultMetadataType.STRUCTURED_APPEND_SEQUENCE) as
    | number
    | undefined
  if (!sequense) return

  // parse = "00010004" みたいになる。
  const parse = sequense.toString(2).padStart(8, '0')
  // potision は parseの前半４桁
  const position = parseInt(parse.substring(0, 4), 2) + 1
  // total は parseの後半４桁
  const total = parseInt(parse.substring(4, 8), 2) + 1

  return { position, total }
}

export const getID = (result: Result) => {
  const meta = result.getResultMetadata()
  return meta.get(ResultMetadataType.STRUCTURED_APPEND_PARITY) as
    | number
    | undefined
}
